//#region Auth
export const LOGIN = 'LOGIN';
export const GET_PROFILE = 'GET_PROFILE';
export const LOGIN_WITH_URL = 'LOGIN_WITH_URL';
export const CREATE_CANVAS_TOKEN = 'CREATE_CANVAS_TOKEN';
export const GET_STUDENT = 'GET_STUDENT';
//#endregion Auth

//#region Notifications
export const GET_LIST_NOTIFICATIONS = 'GET_LIST_NOTIFICATIONS';
//#endregion Notifications

//#region Course
export const GET_LIST_COURSES = 'GET_LIST_COURSES';
export const GET_DETAIL_COURSES = 'GET_DETAIL_COURSES';
export const GET_COURSES_OF_STUDENT = 'GET_COURSES_OF_STUDENT';
export const GET_MODULE_OF_COURSE = 'GET_MODULE_OF_COURSE';
//#endregion Course

//#region User
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
//#endregion User

//#region Tuition
export const GET_LIST_TUITION = 'GET_LIST_TUITION';
export const CREATE_TUITION = 'CREATE_TUITION';
//#endregion Tuition

//#region Exam
export const GET_LIST_EXAM = 'GET_LIST_EXAM';
export const CREATE_EXAM = 'CREATE_EXAM';
//#endregion Exam
